import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import {
  dashboard_icon,
  partager_icon,
  avis_icon,
  settings_icon,
  logout_icon,
  devis_icon,
  attente_icon,
  rdv_icon,
} from '../../../utils/images';
import { ClientContext, ProfileContext } from '../../Contexts/contexts';

function SideMenuUser(props) {
  const profileContext = useContext(ProfileContext);
  const clientContext = useContext(ClientContext);

  const checkForQuotes = () => {
    return (
      clientContext?.clientExpertRelations?.find(
        (relation) => relation?.status >= 0
      ) === undefined
    );
  };

  const checkForAcceptations = () => {
    return (
      clientContext?.clientExpertRelations?.find(
        (relation) => relation?.status < 2 && relation?.status > 0
      ) !== undefined
    );
  };

  const checkForAccepted = () => {
    return (
      clientContext?.clientExpertRelations?.find(
        (relation) => relation?.status >= 2
      ) !== undefined
    );
  };

  return (
    <>
      <div className="side-menu-container">
        <div className="side-menu-upper">
          <div
            className={
              'side-menu-element' + (props.path === '/' ? ' selected' : '')
            }
          >
            <Link to="/">
              <img
                src={dashboard_icon}
                alt="dashboard icon"
                className="side-menu-icon"
              />
              <span>Tableau de bord</span>
            </Link>
          </div>
          {checkForQuotes() && (
            <div
              className={
                'side-menu-element' +
                (props.path === '/quotes' ? ' selected' : '')
              }
            >
              <Link to="/quotes">
                <img
                  src={devis_icon}
                  alt="fiche de devis"
                  className="side-menu-icon"
                />
                <span>Mes devis proposés</span>
              </Link>
            </div>
          )}
          {checkForAcceptations() && (
            <div
              className={
                'side-menu-element' +
                (props.path === '/waiting-acceptations' ? ' selected' : '')
              }
            >
              <Link to="/waiting-acceptations">
                <img
                  src={attente_icon}
                  alt="sablier"
                  className="side-menu-icon"
                />
                <span>En attente d'acceptation</span>
              </Link>
            </div>
          )}
          {checkForAccepted() && (
            <div
              className={
                'side-menu-element' +
                (props.path === '/accepted-quotes' ? ' selected' : '')
              }
            >
              <Link to="/accepted-quotes">
                <img
                  src={rdv_icon}
                  alt="calendrier"
                  className="side-menu-icon"
                />
                <span>Rendez-vous accepté</span>
              </Link>
            </div>
          )}
          <div
            className={
              'side-menu-element' +
              (props.path === '/reviews' ? ' selected' : '')
            }
          >
            <Link to="/reviews">
              <img src={avis_icon} alt="avis icon" className="side-menu-icon" />
              <span>Donner votre avis</span>
            </Link>
          </div>
          {props?.clientExpertRelation !== undefined &&
            props?.clientExpertRelation?.status > 1 && (
              <div
                className={
                  'side-menu-element' +
                  (props.path === '/share-documents' ? ' selected' : '')
                }
              >
                <Link to="/share-documents">
                  <img
                    src={partager_icon}
                    alt="partager icon"
                    className="side-menu-icon"
                  />
                  <span>Partager des documents</span>
                </Link>
              </div>
            )}
        </div>

        <div className="side-menu-bottom">
          <div
            className={
              'side-menu-element' +
              (props.path === '/settings' ? ' selected' : '')
            }
          >
            <Link to="/settings">
              <img
                src={settings_icon}
                alt="settings logo"
                className="side-menu-icon"
              />
              <span>Réglages</span>
            </Link>
          </div>
          <div className="side-menu-element" onClick={profileContext.logout}>
            <Link to="#">
              <img
                src={logout_icon}
                alt="logout logo"
                className="side-menu-icon"
              />
              <span>Se déconnecter</span>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}

export default SideMenuUser;
